import { z } from 'zod';
import { idShapes } from './ids.js';
export const gameSessionPlayerStatusShape = z.object({
    online: z.boolean(),
    pendingTurn: z.boolean(),
});
export const gameSessionPlayerStatusUpdateShape = gameSessionPlayerStatusShape.partial();
export const gameStatusShape = z.discriminatedUnion('status', [
    z.object({
        status: z.literal('pending'),
    }),
    z.object({
        status: z.literal('active'),
    }),
    z.object({
        status: z.literal('complete'),
        winnerIds: z.array(idShapes.User),
    }),
    z.object({
        status: z.literal('abandoned'),
    }),
    z.object({
        status: z.literal('expired'),
    }),
]);
//# sourceMappingURL=status.js.map